import { render, staticRenderFns } from "./LiftTypeIcon.vue?vue&type=template&id=83a1c9f2&lang=pug"
import script from "./LiftTypeIcon.vue?vue&type=script&lang=js"
export * from "./LiftTypeIcon.vue?vue&type=script&lang=js"
import style0 from "./LiftTypeIcon.vue?vue&type=style&index=0&id=83a1c9f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports